import {
  AddInspectionServiceImageRequest,
  CreateInspectionServiceCTARequest,
  CreateInspectionServiceRequest,
  GetInspectionServiceImageRequest,
  RemoveInspectionServiceCTARequest,
  RemoveInspectionServiceImageRequest,
  UpdateInspectionServiceMetadataRequest,
  UpdateInspectionServiceOperationHoursRequest,
  UpdateInspectionServicePaymentMethodsRequest,
  UpdateInspectionServiceStoreIdsRequest,
  UpdateInspectionServiceTagsRequest,
} from './requests/inspection-service-request.ts';
import { apiClient } from './client.tsx';
import {
  AddInspectionServiceImageResponse,
  CreateInspectionServiceCTAResponse,
  CreateInspectionServiceResponse,
  DisableInspectionServiceResponse,
  EnableInspectionServiceResponse,
  GetInspectionServiceImageResponse,
  GetInspectionServiceResponse,
  PauseInspectionServiceResponse,
  RemoveInspectionServiceCTAResponse,
  RemoveInspectionServiceImageResponse,
  RemoveInspectionServiceOperationHoursResponse,
  UpdateInspectionServiceMetadataResponse,
  UpdateInspectionServiceOperationHoursResponse,
  UpdateInspectionServicePaymentMethodsResponse,
  UpdateInspectionServiceStoreIdsResponse,
  UpdateInspectionServiceTagsResponse,
} from './responses/inspection-service-response.ts';

export const createInspectionService = (
  request: CreateInspectionServiceRequest,
) =>
  apiClient
    .post<CreateInspectionServiceResponse>('/v2/inspection_services', request)
    .then((res) => res.data.data);

export const updateInspectionServiceMetadata = (
  request: UpdateInspectionServiceMetadataRequest,
) =>
  apiClient
    .put<UpdateInspectionServiceMetadataResponse>(
      `/v2/inspection_services/${request.serviceId}`,
      request,
    )
    .then((res) => res.data.data);

export const getInspectionService = (serviceId: string) =>
  apiClient
    .get<GetInspectionServiceResponse>(`/v2/inspection_services/${serviceId}`)
    .then((res) => res.data.data);

export const createInspectionServiceCTA = (
  request: CreateInspectionServiceCTARequest,
) =>
  apiClient
    .post<CreateInspectionServiceCTAResponse>(
      `/v2/inspection_services/${request.serviceId}/call_to_actions`,
      request,
    )
    .then((res) => res.data.data);

export const removeInspectionServiceCTA = (
  request: RemoveInspectionServiceCTARequest,
) =>
  apiClient
    .delete<RemoveInspectionServiceCTAResponse>(
      `/v2/inspection_services/${request.serviceId}/call_to_actions/${request.callToActionId}`,
    )
    .then((res) => res.data.data);

export const disableInspectionService = (serviceId: string) =>
  apiClient
    .post<DisableInspectionServiceResponse>(
      `/v2/inspection_services/${serviceId}/disable`,
    )
    .then((res) => res.data.data);

export const enableInspectionService = (serviceId: string) =>
  apiClient
    .post<EnableInspectionServiceResponse>(
      `/v2/inspection_services/${serviceId}/enable`,
    )
    .then((res) => res.data.data);

export const addInspectionServiceImage = (
  request: AddInspectionServiceImageRequest,
) =>
  apiClient
    .post<AddInspectionServiceImageResponse>(
      `/v2/inspection_services/${request.serviceId}/images`,
      request.file,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data.data);

export const removeInspectionServiceImage = (
  request: RemoveInspectionServiceImageRequest,
) =>
  apiClient
    .delete<RemoveInspectionServiceImageResponse>(
      `/v2/inspection_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const getInspectionServiceImage = (
  request: GetInspectionServiceImageRequest,
) =>
  apiClient
    .get<GetInspectionServiceImageResponse>(
      `/v2/inspection_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const updateInspectionServiceOperationHours = (
  request: UpdateInspectionServiceOperationHoursRequest,
) =>
  apiClient
    .put<UpdateInspectionServiceOperationHoursResponse>(
      `/v2/inspection_services/${request.serviceId}/operation_hours`,
      request,
    )
    .then((res) => res.data.data);

export const removeInspectionServiceOperationHours = (serviceId: string) =>
  apiClient
    .delete<RemoveInspectionServiceOperationHoursResponse>(
      `/v2/inspection_services/${serviceId}/operation_hours`,
    )
    .then((res) => res.data.data);

export const pauseInspectionService = (serviceId: string) =>
  apiClient
    .post<PauseInspectionServiceResponse>(
      `/v2/inspection_services/${serviceId}/pause`,
    )
    .then((res) => res.data.data);

export const removeInspectionService = (serviceId: string) =>
  apiClient.delete(`/v2/inspection_services/${serviceId}`);

export const updateInspectionServicePaymentMethods = (
  request: UpdateInspectionServicePaymentMethodsRequest,
) =>
  apiClient
    .put<UpdateInspectionServicePaymentMethodsResponse>(
      `/v2/inspection_services/${request.serviceId}/payment_methods`,
      request,
    )
    .then((res) => res.data.data);

export const updateInspectionServiceTags = (
  request: UpdateInspectionServiceTagsRequest,
) =>
  apiClient
    .put<UpdateInspectionServiceTagsResponse>(
      `/v2/inspection_services/${request.serviceId}/tags`,
      request,
    )
    .then((res) => res.data.data);

export const updateInspectionServiceStoreIds = (
  request: UpdateInspectionServiceStoreIdsRequest,
) =>
  apiClient
    .put<UpdateInspectionServiceStoreIdsResponse>(
      `/v2/inspection_services/${request.serviceId}/stores`,
      request,
    )
    .then((res) => res.data.data);
